import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toDate',
    standalone: false,
})
export class ToDatePipe implements PipeTransform {
    public transform(stringDate: string | Date): Date {
        return new Date(stringDate);
    }
}
